import { Component, OnInit, effect, ChangeDetectionStrategy } from '@angular/core';
import { NavigationError, Router, RouterModule } from '@angular/router';
import { AlertModalWrapperComponent } from '@app/common-codes/components/nested-components/alert-modal-wrapper/alert-modal-wrapper';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { ToastContainerComponent } from '@app/common-codes/components/toast-container/toast-container.component';
import { AuthentificationService } from '@app/common-codes/services/authentification.service';
import { environment } from '../environments/environment';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
  imports: [RouterModule, AlertModalWrapperComponent, ToastContainerComponent],
  changeDetection: ChangeDetectionStrategy.Eager
})

export class AppComponent implements OnInit {
  readonly apiUrl = environment.apiBaseUrl;

  constructor(private router: Router,
    private matwinsVariablesService: MatwinsVariablesService,
    public authentificationService: AuthentificationService) {
    matwinsVariablesService.initBrowserId();

    // debugger;


    this.router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        console.error('Navigation Error:', event);
        this.router.navigate(['/home']);  /// 
      }
    });

  }
  ngOnInit(): void {
    // ATTENTION : ICI Enregistrer toutes les entités connues
    // this.di.initFromRegistry([DataBase, DataMigration, Log]);



  }


}

